export class ApiUrlConstants {
    public static WEDSHED_BASE_URL = "/api/v1";

    public static USER_BASE_URL = this.WEDSHED_BASE_URL + "/user";
    public static BLOG_BASE_URL = this.WEDSHED_BASE_URL + "/blog";
    public static VENUE_BASE_URL = this.WEDSHED_BASE_URL + "/venues";
    public static VENDOR_BASE_URL = this.WEDSHED_BASE_URL + "/vendors";
    public static TERRITORY_BASE_URL = this.WEDSHED_BASE_URL + "/territory";
    public static SEARCH_BASE_URL = this.WEDSHED_BASE_URL + "/search";
    public static FAQ_BASE_URL = this.WEDSHED_BASE_URL + "/faqs";
    public static COUNTRY_BASE_URL = this.WEDSHED_BASE_URL + "/country";
    public static STATE_BASE_URL = this.WEDSHED_BASE_URL + "/state";
    public static REGION_BASE_URL = this.WEDSHED_BASE_URL + "/region";
    public static VENUE_STYLE_BASE_URL = this.WEDSHED_BASE_URL + "/venue-style";
    public static VENDOR_TYPE_BASE_URL = this.WEDSHED_BASE_URL + "/vendor-type";
    public static REAL_WEDDING_BASE_URL = this.WEDSHED_BASE_URL + "/real-wedding";
    public static CONTACT_ENQUIRY_BASE_URL = this.WEDSHED_BASE_URL + "/contact-enquiry";
    public static SETTING_BASE_URL = this.WEDSHED_BASE_URL + "/setting";
    public static NEWSLETTER_BASE_URL = this.WEDSHED_BASE_URL + "/newsletter";
    public static WAITLIST_BASE_URL = this.WEDSHED_BASE_URL + "/waitlist";
    public static BLOG_CATEGORY_BASE_URL = this.WEDSHED_BASE_URL + "/blog-category";
    public static VENUE_FACILITY_BASE_URL = this.WEDSHED_BASE_URL + "/venue-facility";
    public static VENUE_ACCOMMODATION_BASE_URL = this.WEDSHED_BASE_URL + "/venue-accommodation";
    public static ENQUIRY_REASON_BASE_URL = this.WEDSHED_BASE_URL + "/enquiry-reason";
    public static BUSINESS_GOAL_BASE_URL = this.WEDSHED_BASE_URL + "/goal";
    public static RECAPTCHA_BASE_URL = this.WEDSHED_BASE_URL + "/recaptcha";

}
